import { render, staticRenderFns } from "./TopNavBar2.vue?vue&type=template&id=3df1aedb&"
import script from "./TopNavBar2.vue?vue&type=script&lang=js&"
export * from "./TopNavBar2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports